"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const utils_1 = require("@rjsf/utils");
const Accordion_1 = __importDefault(require("../../../global/Accordion/Accordion"));
const AccordionFieldTemplate = (props) => {
    const { description, idSchema, properties, registry, schema, title, uiSchema } = props;
    const options = (0, utils_1.getUiOptions)(uiSchema);
    const DescriptionFieldTemplate = (0, utils_1.getTemplate)('DescriptionFieldTemplate', registry, options);
    const collapsedByDefault = schema['ui:metadata'] && schema['ui:metadata'].collapsedByDefault === true;
    const content = (react_1.default.createElement(react_1.default.Fragment, null,
        description && (react_1.default.createElement(DescriptionFieldTemplate, { id: (0, utils_1.descriptionId)(idSchema), description: description, schema: schema, uiSchema: uiSchema, registry: registry })),
        react_1.default.createElement("div", { className: "form-section" }, properties.map((element, index) => (react_1.default.createElement(react_1.default.Fragment, { key: index }, !element.hidden && element.content))))));
    return react_1.default.createElement(Accordion_1.default, { collapsedByDefault: collapsedByDefault, content: content, id: idSchema.$id, title: title });
};
exports.default = AccordionFieldTemplate;
